import type { NotificationsViewContextData } from "./notifications-view.type";

import { createContext, useContext } from "react";

const config = {
  contextName: "NotificationsViewContext",
  providerName: "NotificationsViewProvider",
};

export const NotificationsViewContext =
  createContext<NotificationsViewContextData | null>(null);

export const useNotificationsView = () => {
  const contextValue = useContext(NotificationsViewContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
